import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-open-questionnaire-modal";

const keys = addTranslations(RESOURCE_NAME, {
    modal_title: {
        en: "Assign a questionnaire",
        fr: "Assigner un questionnaire",
    },
    select_questionnaire_placeholder: {
        en: "Select a questionnaire",
        fr: "Sélectionner un questionnaire",
    },
    questionnaire_name_placeholder: {
        en: "Questionnaire name",
        fr: "Nom du questionnaire",
    },
    set_a_deadline: {
        en: "Set a deadline",
        fr: "Définir une date limite",
    },
    cancel_button: {
        en: "Cancel",
        fr: "Annuler",
    },
    open_button: {
        en: "Open",
        fr: "Ouvrir",
    },
});

export function useOpenQuestionnaireModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
